import angular from 'angular';
import 'angular-ui-router';
//Directives
import { AutoExpandDirective } from './directives/AutoExpandDirective';
import { OpacityColorDirective } from './directives/OpacityColorDirective';
import CounterForDirective from './directives/validation/CounterForDirective';
import NgMimeTypeDirective from './directives/validation/NgMimeTypeDirective';
import NgResolutionDirective from './directives/validation/NgResolutionDirective';
import DragAreaDirective from './directives/DragAreaDirective';
import NewTabAnchorsDirective from './directives/NewTabAnchorsDirective';
import NgCaseDirective from './directives/NgCaseDirective';
import NgEditFinishedDirective from './directives/NgEditFinishedDirective';
import NgSetFocusDirective from './directives/NgSetFocusDirective';
import NgSrcBinaryDirective from './directives/NgSrcBinaryDirective';
import SetFlagDirective from './directives/SetFlagDirective';
import { FragmentActiveDirective } from './directives/FragmentActiveDirective';
import { CustomEventsDirective } from './directives/CustomEventsDirective';
import { OnErrorSrcDirective } from './directives/OnErrorSrcDirective';

//Filters
import IndexByFilter from './filters/IndexByFilter';
import ToArrayFilter from './filters/ToArrayFilter';
import LimitContentFilter from './filters/LimitContentFilter';
import { GreetingFilter } from './filters/GreetingFilter';
import { PropsFilter } from './filters/PropsFilter';
import { TrustedFilter } from './filters/TrustedFilter';
import { EscapeHTML } from './filters/EscapeHTML';

//Services
import FileService from './FileService';
import { CurrentApplicationService } from './CurrentApplicationService';
import { SidebarContentService } from './SidebarContentService';
import { SidebarService } from './SidebarService';
import { PermissionsService } from './PermissionsService';
import { BlipToastService } from './BlipToastService';
import { AlertService } from './AlertService';
import { BlipBucketService } from './BlipBucketService';

//Modules
import { ExceptionHandlerFactory } from 'modules/shared/errorHandler/ExceptionHandlerFactory';
import { applicationTeamModule } from './applicationTeam';
import { callsModule } from './calls';
import { transcriptionModule } from './transcription';
import { BlipComponents } from 'blip-components';

// PATCH: Add $inject to blip-components InputClipboard controller
// blip-components is pre-compiled without $inject annotations, causing DI failures
try {
    const inputClipboardModule = angular.module('blipComponents.inputClipboard');
    // Find the component definition in the _invokeQueue
    for (const invoke of inputClipboardModule._invokeQueue) {
        if (invoke[1] === 'component' && invoke[2][0] === 'inputClipboard') {
            const componentDef = invoke[2][1];
            if (componentDef.controller && !componentDef.controller.$inject) {
                componentDef.controller.$inject = ['clipboard'];
            }
            break;
        }
    }
} catch (e) {
    console.warn('[BlipComponents Patch] Could not patch InputClipboard $inject:', e);
}

//
export default angular
    .module('shared', [
        'ui.router',
        applicationTeamModule,
        callsModule,
        transcriptionModule,
        BlipComponents,
    ])
    .service('FileService', FileService)
    .service('CurrentApplicationService', CurrentApplicationService)
    .service('SidebarContentService', SidebarContentService)
    .service('SidebarService', SidebarService)
    .service('PermissionsService', PermissionsService)
    .service('BlipToastService', BlipToastService)
    .service('AlertService', AlertService)
    .service('BlipBucketService', BlipBucketService)
    .factory('$exceptionHandler', ExceptionHandlerFactory)
    .directive('autoExpand', AutoExpandDirective.factory)
    .directive('opacityColor', OpacityColorDirective.factory)
    .directive('counterFor', CounterForDirective)
    .directive('dragArea', DragAreaDirective)
    .directive('newTabAnchors', NewTabAnchorsDirective)
    .directive('ngCase', NgCaseDirective)
    .directive('ngEditFinished', NgEditFinishedDirective)
    .directive('ngSetFocus', NgSetFocusDirective)
    .directive('ngMimeType', NgMimeTypeDirective)
    .directive('ngResolution', NgResolutionDirective)
    .directive('ngSrcBinary', NgSrcBinaryDirective)
    .directive('setFlag', SetFlagDirective)
    .directive('fragmentActive', FragmentActiveDirective.factory)
    .directive('customEvents', CustomEventsDirective.factory)
    .directive('onErrorSrc', OnErrorSrcDirective.factory)
    .filter('indexBy', IndexByFilter)
    .filter('toArray', ToArrayFilter)
    .filter('limitContent', LimitContentFilter)
    .filter('greetingFilter', GreetingFilter)
    .filter('propsFilter', PropsFilter)
    .filter('trustedFilter', TrustedFilter)
    .filter('escapeHTML', EscapeHTML)
    .name;
